import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import type {
  PostCompanyReviewExperiment2Input,
  PostCompanyReviewExperiment2Payload,
  PostCompanyReviewInput,
  PostCompanyReviewPayload,
} from '@seek/ca-graphql-schema/types';

import type { Logger } from '@seek/logger';
import {
  POST_COMPANY_REVIEW_EXPERIMENT_TWO_MUTATE,
  POST_COMPANY_REVIEW_MUTATE,
} from './graphqlQueries';

export type CompanyReviewService = ReturnType<
  typeof createCompanyReviewService
>;

export const createCompanyReviewService = ({
  client,
  logger,
}: {
  client: ApolloClient<NormalizedCacheObject>;
  logger: Logger;
}) => {
  const submitReview = async (
    input: PostCompanyReviewInput,
  ): Promise<PostCompanyReviewPayload | undefined> => {
    const variables = {
      input,
    };
    const response = await client.mutate<{
      postCompanyReview: PostCompanyReviewPayload;
    }>({
      mutation: POST_COMPANY_REVIEW_MUTATE,
      variables,
    });

    if (response?.errors) {
      logger.error(
        { error: response.errors, variables },
        'Error calling submitReview',
      );
    }

    return response?.data?.postCompanyReview;
  };

  const submitReviewExperimentTwo = async (
    input: PostCompanyReviewExperiment2Input,
  ): Promise<PostCompanyReviewExperiment2Payload | undefined> => {
    const variables: { input: PostCompanyReviewExperiment2Input } = {
      input,
    };
    const response = await client.mutate<{
      postCompanyReviewExperiment2: PostCompanyReviewExperiment2Payload;
    }>({
      mutation: POST_COMPANY_REVIEW_EXPERIMENT_TWO_MUTATE,
      variables,
    });

    if (response?.errors) {
      logger.error(
        { error: response.errors, variables },
        'Error calling submitReviewExperimentTwo',
      );
    }

    return response?.data?.postCompanyReviewExperiment2;
  };

  return {
    submitReview,
    submitReviewExperimentTwo,
  };
};
